/** Номера билетов конкурсов: «№ 731, № 732, № 733», «билет/билета/билетов». */

export function ticketNo(n: number): string {
  return `№ ${n}`;
}

export function ticketRange(first: number, count: number): string {
  return Array.from({ length: count }, (_, i) => ticketNo(first + i)).join(', ');
}

export function ticketWord(count: number): string {
  const tail = count % 100;
  const last = count % 10;
  if (tail >= 11 && tail <= 14) return 'билетов';
  if (last === 1) return 'билет';
  if (last >= 2 && last <= 4) return 'билета';
  return 'билетов';
}
